/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_Action_StepsInputs */

const cs_settings_automation_action_steps = /** @type {(inputs: Settings_Automation_Action_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kroky akcí`)
};

const en_settings_automation_action_steps = /** @type {(inputs: Settings_Automation_Action_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action steps`)
};

/**
* | output |
* | --- |
* | "Action steps" |
*
* @param {Settings_Automation_Action_StepsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_action_steps = /** @type {((inputs?: Settings_Automation_Action_StepsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_Action_StepsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_action_steps(inputs)
	return cs_settings_automation_action_steps(inputs)
});